import { chakra, type HTMLChakraProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

const Base = chakra('div', {
  base: {
    bg: 'surface.subtle',
    position: 'relative',
    overflow: 'hidden',
    animation: 'ehe-skeleton-pulse 1.4s ease-in-out infinite',
  },
});

export interface SkeletonProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'color'> {
  variant?: 'text' | 'rect' | 'circle';
  width?: string;
  height?: string;
}

/** A single shimmering placeholder block. Reduced-motion is honored globally. */
export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
  { variant = 'rect', width, height, ...rest },
  ref,
) {
  const shape: HTMLChakraProps<'div'> =
    variant === 'text'
      ? { height: height ?? '0.85em', borderRadius: 'sm', width: width ?? 'full', my: '0.25em' }
      : variant === 'circle'
        ? { width: width ?? '2.5rem', height: height ?? width ?? '2.5rem', borderRadius: 'full' }
        : { width: width ?? 'full', height: height ?? '1.5rem', borderRadius: 'md' };
  return <Base ref={ref} aria-hidden {...shape} {...rest} />;
});
